module.exports = __webpack_public_path__ + "img/task-3.56ba3296.png";